<template functional>
  <div class="learning-path-course-groups">
    <div
      class="learning-path-course-groups__progress"
      v-if="props.isAuthenticated"
    >
      <component
        :is="injections.components.RadialProgressBar"
        :diameter="30"
        :strokeWidth="3"
        :completed-steps="props.courseProgress"
        :total-steps="props.courseVideoCount"
      >
      </component>
      <p class="learning-path-course-groups__percentage">
        {{ props.courseProgress }}/{{ props.courseVideoCount }}
      </p>
    </div>
    <router-link
      v-if="props.courseVideoCount !== 0"
      class="learning-path-course-groups__tile"
      :to="{
        name: 'course',
        params: { id: props.course.id, slug: props.course.slug },
      }"
    >
      <img
        class="learning-path-course-groups__img"
        :src="`${props.backgroundImg}`"
        onerror="this.style.display='none'"
      />
      <img
        src="@/assets/icons/course/course_icon.png"
        class="learning-path-course-groups__video-icon"
      />
    </router-link>
    <a
      v-else
      class="learning-path-course-groups__tile"
      :href="`https://streaming.ine.com/e/${props.course.slug}`"
    >
      <img
        class="learning-path-course-groups__img"
        :src="`${props.fallbackImg}`"
      />
      <img
        src="@/assets/icons/course/course_icon.png"
        class="learning-path-course-groups__video-icon"
      />
    </a>
    <div class="learning-path-course-groups__details">
      <p class="learning-path-course-groups__title">
        {{ props.course.title }}
        <span
          v-if="props.course.optional === 1"
          class="learning-path-course-groups__optional"
          >Optional</span
        >
      </p>
      <div
        class="learning-path-course-groups__mobile-progress"
        v-if="props.isAuthenticated"
      >
        <component
          :is="injections.components.RadialProgressBar"
          :diameter="30"
          :strokeWidth="3"
          startColor="#00DC9B"
          :completed-steps="props.courseProgress"
          :total-steps="props.courseVideoCount"
        ></component>
        <p class="learning-path-course-groups__mobile-percentage">
          {{ props.courseProgress }}/{{ props.courseVideoCount }}
        </p>
      </div>
      <p class="learning-path-course-groups__lead">
        Instructor:
        <span class="learning-path-course-groups__data">{{
          props.course.presenter.full_name
        }}</span>
      </p>
      <p class="learning-path-course-groups__lead">
        Course Duration:
        <span class="learning-path-course-groups__data">{{
          props.courseDuration
        }}</span>
      </p>
    </div>
    <div class="learning-path-course-groups__btn-wrapper">
      <router-link
        v-if="props.courseVideoCount !== 0"
        class="btn btn__action"
        :to="{
          name: 'course',
          params: { id: props.course.id, slug: props.course.slug },
        }"
      >
        <span v-if="props.courseProgress">Resume</span>
        <span v-else>Begin</span>
        <span class="btn btn__action-icon material-icons"
          >play_circle_filled</span
        >
      </router-link>
      <a
        v-else
        class="btn btn__action"
        :href="`https://streaming.ine.com/e/${props.course.slug}`"
      >
        <span v-if="props.courseProgress">Resume</span>
        <span v-else>Begin</span>
        <span class="btn btn__action-icon material-icons"
          >play_circle_filled</span
        >
      </a>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'LearningPathCourseGroups',
  inject: {
    components: {
      type: Object,
      default() {
        return {
          RadialProgressBar,
        }
      },
    },
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: true,
    },
    courseDuration: {
      type: String,
      required: false,
    },
    isAuthenticated: {
      type: Boolean,
      required: false,
    },
    courseProgress: {
      type: Number,
      required: false,
    },
    courseVideoCount: {
      type: Number,
      required: false,
    },
    fallbackImg: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.learning-path-course-groups {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 15px 10px 15px;
  margin: 20px 0;
  &:after {
    content: '';
    margin: 10px auto 0 auto;
    width: 100%;
    padding-top: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  @include tablet {
    padding: 20px 50px;
    margin: 0 0 0 35px;
    border-left: 1px dotted rgba(255, 255, 255, 0.3);
    &:after {
      margin: 10px auto 0 50px;
    }
  }
  &__progress {
    position: absolute;
    left: -15px;
    top: 60px;
    display: none;
    background-color: #0d0d0d;
    @include tablet {
      display: flex;
      align-items: center;
    }
  }
  &__percentage {
    margin: 0;
    margin-left: 10px;
    color: grey;
  }
  &__tile {
    background: linear-gradient(
      to left bottom,
      rgb(239, 125, 34),
      rgb(249, 170, 13)
    );
    margin: 0 0 0 0;
    height: 120px;
    width: 200px;
    position: relative;
    @include tablet {
      margin: 0 0 0 50px;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__img {
    height: 120px;
    width: 200px;
  }
  &__video-icon {
    position: absolute;
    font-size: 2.5rem;
    left: 10%;
    top: 40%;
    color: var(--white);
  }
  &__details {
    display: flex;
    flex-direction: column;
    width: 70%;
    padding: 0;
    margin: 0;
    @include mobile {
      padding: 0 0 0 50px;
    }
    @include desktop {
      padding: 0 0 0 75px;
      width: auto;
    }
  }
  &__title {
    font-size: 1.2rem;
    color: var(--white);
    margin: 0 0 20px 0;
  }
  &__optional {
    text-transform: uppercase;
    color: var(--orange);
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid var(--gray);
    font-size: 0.8rem;
  }
  &__mobile-progress {
    display: flex;
    align-items: center;
    margin: 0 0 10px 0;
    @include tablet {
      display: none;
    }
  }
  &__mobile-percentage {
    margin: 0 0 0 5px;
    color: var(--white);
  }
  &__lead {
    text-transform: uppercase;
    color: var(--gray);
    margin: 10px 0 0 0;
  }
  &__data {
    color: var(--white);
    text-transform: none;
    margin: 0;
  }
  &__btn-wrapper {
    margin: auto 0 0 auto;
  }
  .btn__action {
    border: 2px solid var(--gray);
  }
}
</style>
